<div class="kpi-card" [class.primary]="isPrimary" [class.total]="isTotal">
  <div class="kpi-card-header">
    <i [class]="getKpiIcon(kpi().type)"></i>
    <span class="kpi-label">{{ kpi().type | enum: "KpiType" }}</span>
  </div>
  <div class="kpi-value">
    {{ formatValue(kpi()) }}
  </div>
  @if (getDelta(kpi()) !== null) {
    <div class="kpi-delta" [ngClass]="getDeltaClass(kpi())" [attr.data-tooltip]="getTooltipContent(kpi())">
      <i [class]="getDeltaIcon(kpi())"></i>
      <span>{{ formatDeltaAndPercentage(kpi()) }}</span>
    </div>
  }
  <div class="kpi-description">
    {{ kpi().description || "" }}
  </div>
</div>
